import {default as Component} from './HeaderComponent'

const HeaderComponent = Component

export default HeaderComponent



// WEBPACK FOOTER //
// ./src/components/HeaderComponent/index.js